import { selectMortgagePromos } from './selectMortgagePromos';
import { IApplicationState } from '../../types/redux';

export const selectHasMortgagePromos = (state: IApplicationState): boolean => {
  const promos = selectMortgagePromos(state);

  return promos.length > 0;
};
